import React, { memo } from 'react'
import { string } from 'prop-types'
import classNames from 'common/helpers/class-names'

const blk = 'co-product'

const Price = memo(({ className, pricePerUnit }) => (
  <strong
    aria-label={`Now ${pricePerUnit}`}
    className={classNames({ className, blk, elt: 'price' })}
  >
    {pricePerUnit}
  </strong>
))

Price.propTypes = {
  className: string,
  pricePerUnit: string,
}
Price.defaultProps = {
  className: '',
  pricePerUnit: '',
}

export default Price



// WEBPACK FOOTER //
// ./shared/interim/product/price/index.js